import { IPaymentTracking } from "../../interfaces/paymentTracking";
import * as DetailComponents from "../../components/paymentCustomerComponents/DetailComponents";
import ChangeStatusComponent from "../../components/paymentCustomerComponents/ChangeStatusComponent";
import CheckRefPayment from "../../components/paymentCustomerComponents/CheckRefPayment";
import { CenterColumns } from "./index.styles";
import { ColumnsType } from "antd/lib/table";

export default function conversDataRowsPaymentCustomer(
  dataUsers: IPaymentTracking[],
  fetchData: () => void
) {
  return dataUsers.map((item: IPaymentTracking, index: number) => [
    <DetailComponents.Timestamp
      key={"Timestamp: " + item.bookingId}
      timestamp={item.timeStamp}
    />,
    <DetailComponents.ProfileComponent
      key={"ProfileComponent: " + item.bookingId}
      name={item.firstName + " " + item.lastName}
      pictureUrl={item.imageUrl}
      displayName={item.displayName}
    />,
    <DetailComponents.Product
      key={"Product: " + item.bookingId}
      productName={item.product.productName}
      productPrice={item.product.price}
      isCoupon={item.isCoupon}
    />,
    <DetailComponents.Description
      key={"Description: " + item.bookingId}
      description={item.descriptions}
      doctorId={item.doctorId}
    />,
    item.isCoupon ? (
      <div
        key={"Coupon: " + item.bookingId}
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={"./coupon.png"}
          alt={`coupon: ${item.productId}`}
          height={40}
          width={40}
          style={{ margin: "0 auto" }}
        />
      </div>
    ) : (
      <CheckRefPayment
        key={"CheckRefPayment: " + item.bookingId}
        refPayment={item.refPayment}
      />
    ),
    <ChangeStatusComponent
      key={"Status: " + item.bookingId}
      status={item.status}
      uid={item.uid}
      bookingId={item.bookingId}
      fetchData={fetchData}
    />,
  ]);
}

export const columns = (fetchData: () => void) => {
  return [
    {
      title: <CenterColumns>วันที่บันทึก</CenterColumns>,
      dataIndex: "timeStamp",
      key: "timeStamp",
      fixed: "left",
      render: (_: string, record: IPaymentTracking) => (
        <DetailComponents.Timestamp timestamp={record.timeStamp} />
      ),
    },
    {
      title: <CenterColumns>ชื่อลูกค้า</CenterColumns>,
      dataIndex: "name",
      key: "name",
      render: (_: string, record: IPaymentTracking) => (
        <DetailComponents.ProfileComponent
          name={`${record.firstName ?? ""} ${record.lastName ?? ""}`}
          pictureUrl={record.imageUrl}
          displayName={record.displayName}
        />
      ),
    },
    {
      title: <CenterColumns>ข้อมูลสินค้า</CenterColumns>,
      dataIndex: "product",
      key: "product",
      render: (_: string, record: IPaymentTracking) => (
        <DetailComponents.Product
          productName={record.product.productName}
          productPrice={record.product.price}
        />
      ),
    },
    {
      title: <CenterColumns>รายละเอียด</CenterColumns>,
      dataIndex: "descriptions",
      key: "descriptions",
      width: 300,
      render: (_: string, record: IPaymentTracking) => (
        <DetailComponents.Description
          description={record.descriptions}
          doctorId={record.doctorId}
        />
      ),
    },
    {
      title: <CenterColumns>สลิปจ่ายเงิน</CenterColumns>,
      dataIndex: "refPayment",
      key: "refPayment",
      render: (_: string, record: IPaymentTracking) =>
        record.isCoupon ? (
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={"./coupon.png"}
              alt={`coupon: ${record.productId}`}
              height={40}
              width={40}
              style={{ margin: "0 auto" }}
            />
          </div>
        ) : (
          <CheckRefPayment refPayment={record.refPayment} />
        ),
    },
    {
      title: <CenterColumns>สถานะ</CenterColumns>,
      dataIndex: "other",
      key: "other",
      render: (_: string, record: IPaymentTracking) => (
        <ChangeStatusComponent
          key={"Status: " + record.bookingId}
          status={record.status}
          uid={record.uid}
          bookingId={record.bookingId}
          fetchData={fetchData}
        />
      ),
    },
  ] as ColumnsType<IPaymentTracking>;
};
